/* eslint-disable */

import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

// -- css -- //
import "../css/reset.css";
import "../css/App.css";
import "../css/App.font.css";
import "../css/common.css";

/*
.
  Main 에서 element를 App 컴포넌트로 감싸져 있는 라우터는 
  Outlet 컴포넌트를 거쳐서 렌더링 됨      
*/

function App() {
  return (
    <>
      {/* Nav */}
      <Navbar className='nav' />

      {/* body */}
      <div className='body'>
        <Outlet />
      </div>

      <Footer className='footer' />
    </>
  );
}

export default App;
